var map = {
	"./belgie-Dinsdag.png": 4563,
	"./belgie-Donderdag.png": 5067,
	"./belgie-Maandag.png": 5162,
	"./belgie-Vrijdag.png": 9720,
	"./belgie-Woensdag.png": 9573,
	"./belgie-Zaterdag.png": 515,
	"./belgie-Zondag.png": 948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6052;